import { Card } from "components/Card/Card";
import { useI18n } from "i18n/I18nProvider";

import lizard from "resources/lizardGreen.svg";

import styles from "./styles.module.scss";
import { useLayoutEffect, useRef } from "react";

type AnimalCardPlaceholderProps = React.DetailedHTMLProps<
  React.HTMLAttributes<HTMLDivElement>,
  HTMLDivElement
> & {
  hoverable?: boolean;
  innerRef?: (el: HTMLDivElement) => void;
};

export const AnimalCardPlaceholder: React.FC<AnimalCardPlaceholderProps> = ({
  hoverable,
  className,
  innerRef,
  ...props
}) => {
  const { t } = useI18n();
  const cardRef = useRef<HTMLDivElement>(null);

  useLayoutEffect(() => {
    if (cardRef.current) {
      innerRef?.(cardRef.current);
    }
  }, [innerRef]);

  return (
    <Card
      title={t("animal.fallback")}
      {...props}
      cardRef={cardRef}
      hoverable={hoverable}
      cardClassName={className}
    >
      <div className={styles.cardContent}>
        <div className={styles.image}>
          <img src={lizard} />
        </div>
      </div>
    </Card>
  );
};
